import type { MapMarkerWithSiblings } from "../map.type";

import { getMapMarkerItemsCount } from "../map.helper";

export const getMapMarkerIconGroupOptions = (marker: MapMarkerWithSiblings) => {
  const count = getMapMarkerItemsCount(marker);

  if (count <= 1) return { showGroup: false, count };

  const siblings = marker.siblings ?? [];
  const showGroup = marker.type === "asset" && !siblings.length ? false : true;

  return {
    showGroup,
    count,
  };
};
